import { Modal, Button, Input } from "antd";
import { useEffect, useState } from "react";
import PaymentPayingInSlipModal from "./PaymentPayingInSlipModal";
import useTranslation from "../../../hooks/TranslationContext";

// defines
type Props = {
  open: boolean;
  closeOnSave?: boolean;
  onSave: () => void;
  onCancel: () => void;
};

export default function PaymentTypePickerModal({ open, closeOnSave = false, onSave, onCancel }: Props) {
  const { t } = useTranslation();

  const [methods, setMethods] = useState<any[]>([{
    id: "payingInSlip",
    name: t("paying-in-slip"),
    isActive: true
  }]);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [amount, setAmount] = useState<any>(null);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      setMethods([
        ...methods,
        {
          id: "online",
          name: t("online"),
          isActive: true
        }
      ])
    }
  }, [])

  useEffect(() => {
    if (amount) {
      setErrorMessage(null)
    }
  }, [amount])

  const onButtonClick = (mode: string) => {
    if (!amount) {
      setErrorMessage(t("enter-amount-and-choose-option"))
      return
    }
    else {
      switch (mode) {
        case "payingInSlip":
          setModalOpen(true);
          break;
        case "online":

          break;

        default:
          break;
      }
    }



  }

  const onModalSave = () => {
    setModalOpen(false);
  };

  const onAmountChange = (e: any) => {
    setAmount(e?.target?.value)
  }

  return (
    <Modal
      title={t("payment-type")}
      open={open}
      onCancel={onCancel}
      footer={null}
    >

      <p>{t("enter-amount-and-choose-payment-type")}</p>
        <div>
          <label className="block text-sm font-medium">{t("amount")}</label>
          <Input value={amount} onChange={onAmountChange} placeholder={t("enter-amount-in-rial")} />
          {errorMessage && <p className="text-red-500 text-sm">{errorMessage}</p>}
        </div>
        <div className="flex justify-center gap-4 mt-4">
          {
            methods.filter(item => item.isActive).map(item =>
            <>
              <Button
                onClick={() => onButtonClick(item.id)}
                className="bg-gray-200 text-gray-800 hover:bg-gray-300"
              >
                {item.name}
              </Button>
            </>
            )
          }
        </div>
        {isModalOpen && (
          <PaymentPayingInSlipModal
            open={isModalOpen}
            amount={amount}
            onSave={onModalSave}
            onCancel={() => setModalOpen(false)}
          />
        )}
    </Modal>
  );
};
